

import React, { useState, useEffect } from "react";
import { useScrollAnimation } from "../../../../utils/Utils";
import { Link, useOutletContext } from "react-router-dom";
import { upcomingEvents, pastEvents, featuredEvents } from "./webinarData";
import { Calendar, Clock, MapPin, Star, AlertCircle , RefreshCw, Home} from 'lucide-react';
import webinarImage from "../../../../Assets/webinar/Webinar may 20th_EventPage.png";
const Webinar = () => {
  const [activeLink, setActiveLink] = useState("upcoming");
  const { linkClicked } = useOutletContext();

  const handleNavLinkClick = (link) => {
    setActiveLink(link);
  };

  useScrollAnimation();

  return (
    <div>
      
      {/* Hero Section */}
       <section>
         <div className="webinar_main">
           {/* Hero section content can go here if needed */}
         </div>
       </section>
      {/* Navigation Tabs */}

      <section>
        <ul
          className="flex flex-wrap justify-center font-medium text-center border-b border-b-[#d1d5db]"
          style={{ backgroundColor: "#EFEFEF" }}
        >
          <li
            onClick={() => handleNavLinkClick("upcoming")}
            className="cursor-pointer w-full sm:w-1/4 border-r border-r-black font-[500]"
          >
            <div className="flex flex-col items-center">
              <span className={`text-[18px] py-4 px-2 ${activeLink === "upcoming" ? "text-darkblue" : "text-[#333]"}`}>
                Upcoming Events
              </span>
            </div>
          </li>
          <li
            onClick={() => handleNavLinkClick("past")}
            className="cursor-pointer w-full sm:w-1/4 border-r border-r-black font-[500]"
          >
            <div className="flex flex-col items-center">
              <span className={`text-[18px] py-4 px-2 ${activeLink === "past" ? "text-darkblue" : "text-[#333]"}`}>
                Past Events
              </span>
            </div>
          </li>
          <li
            onClick={() => handleNavLinkClick("featured")}
            className="cursor-pointer w-full sm:w-1/4 font-[500]"
          >
            <div className="flex flex-col items-center">
              <span className={`text-[18px] py-4 px-2 ${activeLink === "featured" ? "text-darkblue" : "text-[#333]"}`}>
                Featured Events
              </span>
            </div>
          </li>
        </ul>

        {/* Content Based on Active Tab */}
        <div className="container mx-auto px-4 py-8">
          {activeLink === "upcoming" && (
            <div className="space-y-8">
              {upcomingEvents && upcomingEvents.length > 0 ? (
                upcomingEvents.map((event) => (
                  <UpcomingEventCard key={event.id} event={event} linkClicked={linkClicked} />
                ))
              ) : (
                <EmptyStateAnimation 
                  message="No upcoming events scheduled at the moment." 
                  subMessage="Further updates regarding events will be displayed soon. Visit our website frequently for further details." 
                />
              )}
            </div>
          )}

          {activeLink === "past" && (
            <div className="space-y-8">
              {pastEvents && pastEvents.length > 0 ? (
                pastEvents.map((event) => (
                  <PastEventCard key={event.id} event={event} linkClicked={linkClicked} />
                ))
              ) : (
                <EmptyStateAnimation 
                  message="No past events to display." 
                  subMessage="Our event archive will be updated soon. Visit our website frequently for further details." 
                />
              )}
            </div>
          )}

          {activeLink === "featured" && (
            <div className="space-y-8">
              {featuredEvents && featuredEvents.length > 0 ? (
                featuredEvents.map((event) => (
                  <FeaturedEventCard key={event.id} event={event} linkClicked={linkClicked} />
                ))
              ) : (
                <EmptyStateAnimation 
                  message="No featured events at this time." 
                  subMessage="Our featured events will be updated soon. Visit our website frequently for further details." 
                />
              )}
            </div>
          )}
        </div>
      </section>


    </div>
  );
};

// Empty State Animation Component

const EmptyStateAnimation = ({ message, subMessage }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
 
  useEffect(() => {
    // Fade in animation with slight delay
    const visibilityTimer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    
    // Simulate progress checking
    const progressInterval = setInterval(() => {
      setLoadingProgress(prev => {
        const newProgress = prev + 1;
        return newProgress <= 100 ? newProgress : 100;
      });
    }, 50);
    
    return () => {
      clearTimeout(visibilityTimer);
      clearInterval(progressInterval);
    };
  }, []);
  
  // Function to refresh the page
  const handleRefresh = () => {
    window.location.reload();
  };
  
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4" 
         style={{ background: 'linear-gradient(to bottom, #f9fafb, #e1effe)' }}>
      <div 
        className={`transition-all duration-1000 ease-out transform ${
          isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-10 scale-95'
        }`}
      >
        <div className="rounded-xl  p-6 text-center mx-auto overflow-hidden relative"
             style={{ backgroundColor: '#ffffff', borderTop: '4px solid #3b82f6', maxWidth: '800px', minHeight: '280px' }}>
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 left-0 w-full h-full opacity-10" 
                 style={{
                   backgroundImage: 'radial-gradient(circle, #4338ca 1px, transparent 1px)', 
                   backgroundSize: '20px 20px',
                   backgroundColor: 'transparent'
                 }}></div>
          </div>
          
          <div className="flex flex-col md:flex-row md:items-center">
            {/* Icon container with pulse animation */}
            <div className="relative mb-4 md:mb-0 md:mr-8 flex-shrink-0 self-center">
              <div className="absolute inset-0 rounded-full opacity-20 animate-ping"
                   style={{ backgroundColor: '#3b82f6' }}></div>
              <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center relative z-10 shadow-md"
                   style={{ backgroundColor: '#eff6ff' }}>
                <AlertCircle className={`w-8 h-8 ${isVisible ? 'animate-bounce' : ''}`} 
                             style={{ color: '#3b82f6' }} />
              </div>
            </div>
            
            <div className="flex-grow text-left">
              {/* Message with subtle animation */}
              <h3 className={`text-xl font-bold mb-2 ${isVisible ? 'animate-fadeIn' : ''}`}
                  style={{animationDelay: '400ms', color: '#1f2937'}}>{message}</h3>
              
              <p className={`mb-4 leading-relaxed ${isVisible ? 'animate-fadeIn' : ''}`}
                 style={{animationDelay: '600ms', color: '#4b5563'}}>{subMessage}</p>
              
              {/* Action buttons with hover effects */}
              {/* <div className={`flex flex-wrap gap-4 mb-4 ${isVisible ? 'animate-fadeIn' : ''}`}
                   style={{animationDelay: '800ms'}}>
                <button
                  className="font-medium py-2 px-4 rounded-lg transition-all duration-300 flex items-center gap-2 hover:shadow-md cursor-pointer"
                  onClick={() => window.location.reload()}
                  style={{ backgroundColor: '#eff6ff', color: '#1d4ed8' }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#dbeafe'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#eff6ff'}
                >
                  <RefreshCw className="w-4 h-4 transition-transform duration-500" />
                  <span onClick={() => window.location.reload()}>Refresh Page</span>
                </button>
                
                <Link to="/" 
                      className="font-medium py-2 px-4 rounded-lg transition-all duration-300 hover:shadow-lg flex items-center gap-2 cursor-pointer"
                      style={{ backgroundColor: '#2563eb', color: '#ffffff' }}
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}>
                  <Home className="w-4 h-4" />
                  <span >Back to Home</span>
                </Link>
              </div> */}
    {/* <div className={`flex flex-wrap gap-4 mb-4 ${isVisible ? 'animate-fadeIn' : ''}`}
         style={{animationDelay: '800ms'}}>
      <button
        className="font-medium py-2 px-4 rounded-lg transition-all duration-300 flex items-center gap-2 hover:shadow-md cursor-pointer"
        onClick={() => window.location.reload()}
        style={{ backgroundColor: '#eff6ff', color: '#1d4ed8' }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#dbeafe'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#eff6ff'}
      >
        <RefreshCw className="w-4 h-4 transition-transform duration-500" />
        <span>Refresh Page</span>
      </button>
      
      <Link to="/" 
        className="font-medium py-2 px-4 rounded-lg transition-all duration-300 hover:shadow-lg flex items-center gap-2 cursor-pointer"
        style={{ backgroundColor: '#2563eb', color: '#ffffff' }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}>
        <Home className="w-4 h-4" />
        <span>Back to Home</span>
      </Link>
    </div> */}
              
              {/* Progress indicator */}
              <div className={`relative ${isVisible ? 'animate-fadeIn' : ''}`} style={{animationDelay: '1000ms'}}>
                <div className="h-2 w-full rounded-full overflow-hidden"
                     style={{ backgroundColor: '#f3f4f6' }}>
                  <div 
                    className="h-full rounded-full transition-all duration-300 ease-out"
                    style={{ 
                      width: `${loadingProgress}%`,
                      background: 'linear-gradient(to right, #60a5fa, #3b82f6)'
                    }}
                  ></div>
                </div>
                <div className="text-xs mt-2 flex items-center gap-2" style={{ color: '#6b7280' }}>
                  <span className="inline-block w-2 h-2 rounded-full animate-pulse" 
                        style={{ backgroundColor: '#3b82f6' }}></span>
                  Checking for updates... {loadingProgress}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


// Upcoming Event Card Component

function UpcomingEventCard({ event, linkClicked }) {
  const [isHovered, setIsHovered] = useState(false);
  
  // Calculate days remaining
  const calculateDaysRemaining = () => {
    const eventDate = new Date(event.eventDate);
    const today = new Date();
    const diffTime = eventDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  return (
    <div 
      className="overflow-hidden "
      style={{ borderColor: "#e5e7eb" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
        {/* Left section - Event information */}
        <div className="md:col-span-2 p-6" style={{ backgroundColor: "#ffffff" }}>
          <div className="flex items-center mb-3">
            <div className="w-3 h-3 rounded-full mr-2" style={{ backgroundColor: "#3b82f6" }}></div>
            <span className="text-sm font-medium uppercase tracking-wider" style={{ color: "#3b82f6" }}>Live Event</span>
          </div>
          
          <h3 className="text-2xl font-bold mb-2" style={{ color: "#1f2937" }}>{event.mainHeadline}</h3>
          <p className="italic mb-4 text-sm" style={{ color: "#4b5563" }}>{event.subHeadline}</p>
          
          <div className="space-y-3 mb-6">
            <div className="flex items-center">
              <Calendar className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.eventDate}</span>
            </div>
            
            <div className="flex items-center">
              <Clock className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.time}</span>
            </div>
            
            <div className="flex items-center">
              <MapPin className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.location}</span>
            </div>
          </div>
          
          <p className="mb-6 leading-relaxed" style={{ color: "#4b5563" }}>{event.smallDescription}</p>
          
          <Link to={`/insights/webinar/webinarregistration/${event.id}`} onClick={linkClicked} className="w-full">
            <button
              className="rounded-md px-6 py-3 font-medium transition-all duration-300 shadow-md hover:shadow-lg"
              style={{
                backgroundColor: isHovered ? "#1d4ed8" : "#2563eb",
                color: "#ffffff",
                transform: isHovered ? "scale(1.02)" : "scale(1)",
              }}
            >
              Register Now
            </button>
          </Link>
        </div>
        
        {/* Right section - Image and days counter */}
        <div className="relative">
          {/* Event image */}
          <div className="h-full w-full">
            {event.imageUrl ? (
              <img 
                src={webinarImage} 
                alt={event.mainHeadline} 
                className="h-full w-full object-cover"
              />
            ) : (
              <img 
                src="/api/placeholder/400/320" 
                alt="Event" 
                className="h-full w-full object-cover"
              />
            )}
          </div>
          
          {/* Days remaining overlay */}
          <div className="absolute top-2 right-96 rounded-lg shadow-md p-1 text-center min-w-20" 
               style={{ backgroundColor: "rgba(255, 255, 255, 0.9)" }}>
            <div className="text-3xl font-bold" style={{ color: "#2563eb" }}>{calculateDaysRemaining()}</div>
            <div className="text-xs uppercase tracking-wider font-medium" style={{ color: "#4b5563" }}>
              {calculateDaysRemaining() === 1 ? 'Day Left' : 'Days Left'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Past Event Card Component
function PastEventCard({ event, linkClicked }) {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      className="overflow-hidden "
      style={{ borderColor: "#e5e7eb" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
        {/* Left section - Event information */}
        <div className="md:col-span-2 p-6" style={{ backgroundColor: "#ffffff" }}>
          <div className="flex items-center mb-3">
            <div className="w-3 h-3 rounded-full mr-2" style={{ backgroundColor: "#8b5cf6" }}></div>
            <span className="text-sm font-medium uppercase tracking-wider" style={{ color: "#8b5cf6" }}>Recorded Event</span>
          </div>
          
          <h3 className="text-2xl font-bold mb-2" style={{ color: "#1f2937" }}>{event.mainHeadline}</h3>
          <p className="italic mb-4 text-sm" style={{ color: "#4b5563" }}>{event.subHeadline}</p>
          
          <div className="space-y-3 mb-6">
            <div className="flex items-center">
              <Calendar className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.eventDate}</span>
            </div>
            
            <div className="flex items-center">
              <Clock className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.time}</span>
            </div>
            
            <div className="flex items-center">
              <MapPin className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.location}</span>
            </div>
          </div>
          
          <p className="mb-6 leading-relaxed" style={{ color: "#4b5563" }}>{event.smallDescription}</p>
          
          <Link to={`/insights/webinar/webinarregistration/${event.id}`} onClick={linkClicked} className="w-full">
            <button
              className="rounded-md px-6 py-3 font-medium transition-all duration-300 shadow-md hover:shadow-lg"
              style={{
                backgroundColor: isHovered ? "#7c3aed" : "#8b5cf6",
                color: "#ffffff",
                transform: isHovered ? "scale(1.02)" : "scale(1)",
              }}
            >
              Watch Now
            </button>
          </Link>
        </div>
        
        {/* Right section - Image */}
        <div className="relative">
          {/* Event image */}
          <div className="h-full w-full">
            {event.imageUrl ? (
              <img 
                src={event.imageUrl} 
                alt={event.mainHeadline} 
                className="h-full w-full object-cover"
              />
            ) : (
              <img 
                src="/api/placeholder/400/320" 
                alt="Event" 
                className="h-full w-full object-cover"
              />
            )}
          </div>
          
          {/* Past event badge */}
          <div className="absolute top-4 right-4 rounded-lg shadow-md p-3 text-center" 
               style={{ backgroundColor: "rgba(255, 255, 255, 0.9)" }}>
            <div className="text-xs uppercase tracking-wider font-medium" style={{ color: "#8b5cf6" }}>
              Available Now
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Featured Event Card Component
function FeaturedEventCard({ event, linkClicked }) {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      className="overflow-hidden "
      style={{ borderColor: "#e5e7eb" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
        {/* Left section - Event information */}
        <div className="md:col-span-2 p-6" style={{ backgroundColor: "#ffffff" }}>
          <div className="flex items-center mb-3">
            <div className="w-3 h-3 rounded-full mr-2" style={{ backgroundColor: "#10b981" }}></div>
            <span className="text-sm font-medium uppercase tracking-wider mr-2" style={{ color: "#10b981" }}>Featured Event</span>
            <Star className="w-5 h-5" style={{ color: "#fbbf24", fill: "#fbbf24" }} />
          </div>
          
          <h3 className="text-2xl font-bold mb-2" style={{ color: "#1f2937" }}>{event.mainHeadline}</h3>
          <p className="italic mb-4 text-sm" style={{ color: "#4b5563" }}>{event.subHeadline}</p>
          
          <div className="space-y-3 mb-6">
            <div className="flex items-center">
              <Calendar className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.eventDate}</span>
            </div>
            
            <div className="flex items-center">
              <Clock className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.time}</span>
            </div>
            
            <div className="flex items-center">
              <MapPin className="w-5 h-5 mr-3" style={{ color: "#6b7280" }} />
              <span style={{ color: "#374151" }}>{event.location}</span>
            </div>
          </div>
          
          <p className="mb-6 leading-relaxed" style={{ color: "#4b5563" }}>{event.smallDescription}</p>
          
          <Link to={`/insights/webinar/webinarregistration/${event.id}`} onClick={linkClicked} className="w-full">
            <button
              className="rounded-md px-6 py-3 font-medium transition-all duration-300 shadow-md hover:shadow-lg"
              style={{
                backgroundColor: isHovered ? "#059669" : "#10b981",
                color: "#ffffff",
                transform: isHovered ? "scale(1.02)" : "scale(1)",
              }}
            >
              Watch Now
            </button>
          </Link>
        </div>
        
        {/* Right section - Image */}
        <div className="relative">
          {/* Event image */}
          <div className="h-full w-full">
            {event.imageUrl ? (
              <img 
                src={event.imageUrl} 
                alt={event.mainHeadline} 
                className="h-full w-full object-cover"
              />
            ) : (
              <img 
                src="" 
                alt="Event" 
                className="h-full w-full object-cover"
              />
            )}
          </div>
          
          {/* Featured badge */}
          <div className="absolute top-4 right-4 rounded-lg shadow-md p-3 text-center" 
               style={{ backgroundColor: "rgba(255, 255, 255, 0.9)" }}>
            <div className="flex items-center">
              <Star className="w-4 h-4 mr-1" style={{ color: "#fbbf24", fill: "#fbbf24" }} />
              <div className="text-xs uppercase tracking-wider font-medium" style={{ color: "#10b981" }}>
                Featured
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Add this to your CSS
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes progressBar {
    0% { width: 0%; }
    50% { width: 70%; }
    100% { width: 100%; }
  }
  
  .animate-progressBar {
    animation: progressBar 3s ease-in-out infinite;
  }
`;
document.head.appendChild(styleSheet);

export default Webinar;